import {Box} from '@mui/system';

import {
  CTypeOptionCheckout,
  TypeOptionCheckout,
} from '@/dataSource/src/api/payment-link/entities';

const IconSizes = {
  Circle: {
    width: 20,
    height: 24,
  },
  Image: {
    width: 40,
    height: 25,
  },
};

export const ICON_MAP = {
  [CTypeOptionCheckout.DEBIT_CARD]: (
    <Box className="payment-link-fees-item-icon-circle">
      <img
        src="/assets/icons/card_numbers.svg"
        alt="credit"
        width={IconSizes.Circle.width}
        height={IconSizes.Circle.height}
      />
    </Box>
  ),
  [CTypeOptionCheckout.CREDIT_CARD]: (
    <Box className="payment-link-fees-item-icon-circle">
      <img
        src="/assets/icons/add_card.svg"
        alt="credit"
        width={IconSizes.Circle.width}
        height={IconSizes.Circle.height}
      />
    </Box>
  ),
  [CTypeOptionCheckout.VENMO]: (
    <img
      src="/assets/icons/venmo.webp"
      alt="venmo"
      width={IconSizes.Image.width}
      height={IconSizes.Image.height}
    />
  ),
  [CTypeOptionCheckout.APPLE_PAY]: (
    <img
      src="/assets/icons/apple_pay.svg"
      alt="apple"
      width={IconSizes.Image.width}
      height={IconSizes.Image.height}
    />
  ),
  [CTypeOptionCheckout.GOOGLE_PAY]: (
    <img
      src="/assets/icons/google_pay.svg"
      alt="google"
      width={IconSizes.Image.width}
      height={IconSizes.Image.height}
    />
  ),
};

export const INSTANT_SET = new Set([
  CTypeOptionCheckout.DEBIT_CARD,
  CTypeOptionCheckout.CREDIT_CARD,
  CTypeOptionCheckout.VENMO,
  CTypeOptionCheckout.APPLE_PAY,
  CTypeOptionCheckout.GOOGLE_PAY,
]);

export const getIcon = (type: TypeOptionCheckout) => ICON_MAP[type] ?? null;
export const getIsInstant = (type: TypeOptionCheckout) => INSTANT_SET.has(type);
